import H3 from "@material-tailwind/react/Heading3";
import React from 'react';
import Fade from 'react-reveal/Fade';
import fullstackProjects from "../Constants/FullStackProjects";
import ProjectCard from './ProjectCard';
const Projects = () => {
    return (
        <div id="projects" className="w-full min-h-screen p-4 mt-12">
            <H3 color="lightBlue">Projects</H3>
            <div className="w-full flex flex-col pt-8">
                {
                    fullstackProjects.map((projcet, index) => {
                        if (index % 2 === 0) {
                            return <Fade left><ProjectCard key={index} data={projcet}></ProjectCard></Fade>
                        }
                        else {
                            return <Fade right><ProjectCard key={index} data={projcet}></ProjectCard></Fade>
                        }
                    })
                }
            </div>
        </div>

    );
};

export default Projects;